module.exports = __webpack_public_path__ + "img/acuerdoCapte02.5e090d23.jpg";